/**
 * Edge length, in CSS pixels, at which a symbol of `extent` modules gets a whole
 * number of device pixels per module — the closest one to `requested`.
 *
 * A QR code is sampled on its module grid, so what a scanner needs is that every
 * module is the same width. It is not: at 208 CSS pixels over 61 modules the
 * rasteriser rounds each module on its own and lays down 3px here and 4px there.
 * The jitter grows as the ratio moves away from a whole number, which is why the
 * same symbol reads on a 2x display and fails on a 1x or a 125%-scaled one.
 */
export function snapToWholeModules(
  requested: number,
  extent: number,
  devicePixelRatio: number,
): number {
  const ratio = devicePixelRatio > 0 ? devicePixelRatio : 1;
  const devicePixelsPerModule = Math.max(
    1,
    Math.round((requested * ratio) / extent),
  );

  return (devicePixelsPerModule * extent) / ratio;
}
